import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PatheditorService {
  mousedown: void;
  mousemove: void;
  mouseup: void;
  fill = false;
  line = true;
  opacity = 1; // Default opacity (0-1)
  strokeDasharray = ''; // Stroke dash pattern (e.g., '10,5' for dashed, '2,2' for dotted)
  savedhistory = [''];
  currenthistory: number = 1;

  constructor() { }


  resetHistory() {
    this.savedhistory = [''];
    this.currenthistory = 1;
  }

  removeEventListeners() {
    // remove listeners by copy.. check for errors!!
    let svgElementold = document.getElementById("svgElement");
    if (svgElementold) {
      var new_element = svgElementold.cloneNode(true);
      if (svgElementold.parentNode) {
        svgElementold.parentNode.replaceChild(new_element, svgElementold);
      }
    }
  }

  saveHistory() {
    console.log(this.currenthistory, this.savedhistory);
    if (this.currenthistory < this.savedhistory.length) {
      this.savedhistory.splice(this.currenthistory, this.savedhistory.length - 1)
    }

    let svgElement = document.getElementById("svgElement");
    if (svgElement) {
      this.savedhistory.push(JSON.stringify(svgElement.innerHTML));
    }
    this.currenthistory = this.currenthistory + 1
  }

  reverseHistory() {
    if (this.currenthistory === 1) { return; }
    let svgElement = document.getElementById("svgElement");
    console.log(this.savedhistory, this.currenthistory)
    if (svgElement) {
      svgElement.innerHTML = JSON.parse(this.savedhistory[this.currenthistory - 1]);
    }
    this.currenthistory = this.currenthistory - 1;
  }

  forwardHistory() {
    if (this.currenthistory > this.savedhistory.length - 1) { return; }
    let svgElement = document.getElementById("svgElement");
    console.log(this.savedhistory, this.currenthistory)
    if (svgElement) {
      svgElement.innerHTML = JSON.parse(this.savedhistory[this.currenthistory]);
    }
    this.currenthistory = this.currenthistory + 1;
  }

  /**
   * Generate SVG path data for a star shape
   * @param cx Center X coordinate
   * @param cy Center Y coordinate
   * @param outerRadius Radius of outer points
   * @param innerRadius Radius of inner points
   * @param points Number of star points (default: 5)
   */
  private generateStarPath(cx: number, cy: number, outerRadius: number, innerRadius: number, points: number = 5): string {
    const angle = Math.PI / points;
    let path = '';
    
    for (let i = 0; i < 2 * points; i++) {
      const r = i % 2 === 0 ? outerRadius : innerRadius;
      const currAngle = i * angle - Math.PI / 2; // Start from top
      const x = cx + r * Math.cos(currAngle);
      const y = cy + r * Math.sin(currAngle);
      
      if (i === 0) {
        path = `M ${x} ${y}`;
      } else {
        path += ` L ${x} ${y}`;
      }
    }
    
    return path + ' Z';
  }

  /**
   * Generate SVG path data for a regular polygon
   * @param cx Center X coordinate
   * @param cy Center Y coordinate
   * @param radius Radius from center to vertices
   * @param sides Number of sides (default: 6)
   */
  private generatePolygonPath(cx: number, cy: number, radius: number, sides: number = 6): string {
    const angle = (2 * Math.PI) / sides;
    let path = '';
    
    for (let i = 0; i < sides; i++) {
      const currAngle = i * angle - Math.PI / 2; // Start from top
      const x = cx + radius * Math.cos(currAngle);
      const y = cy + radius * Math.sin(currAngle);
      
      if (i === 0) {
        path = `M ${x} ${y}`;
      } else {
        path += ` L ${x} ${y}`;
      }
    }
    
    return path + ' Z';
  }

  startNewWhiteboard(canvas: { width: any; height: any; }, whiteboardsmoothing: any, shapedraw: string, whiteboardcolor: string, whiteboardstokewidth: number, whiteboardfillcolor: string): void {
    window.scrollTo(0, 0);

    setTimeout(() => {
      //  https://stackoverflow.com/questions/40324313/svg-smooth-freehand-drawing
      let bufferSize: number;
      let svgElement = document.getElementById("svgElement");
      let rect = svgElement ? svgElement.getBoundingClientRect() : { top: 0, left: 0, width: 0, height: 0 };
      let path: SVGPathElement | null = null;
      let strPath: string;
      let buffer: any[] = []; // Contains the last positions of the mouse cursor
      let firstpoint: { x: any; y: any; } | null;
      let firstpointcircle;
      let w = canvas.width.replace('px', '');
      let h = canvas.height.replace('px', '');
      let newview = '0 0 ' + w + ' ' + h;
      if (svgElement) {
        svgElement.setAttribute('viewBox', newview);
      }
      this.saveHistory();

      if (!svgElement) return;
      this.mousedown = svgElement.addEventListener("mousedown", (e) => {

        //bs = document.getElementById("cmbBufferSize") as unknown;
        bufferSize = whiteboardsmoothing;
        path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

        // lines properties
        if (this.line) {
          path.setAttribute("stroke", whiteboardcolor);
          path.setAttribute("stroke-width", whiteboardstokewidth + 'px');
          // Apply stroke dash pattern if set
          if (this.strokeDasharray) {
            path.setAttribute("stroke-dasharray", this.strokeDasharray);
          }
        } else {
          path.setAttribute("stroke-width", 0+ 'px');
        }

        // set fill properties
        // console.log(whiteboardfillecolor)
        if (this.fill) {
          path.setAttribute("fill", whiteboardfillcolor);
          //   path.setAttribute('fill-rule', 'evenodd');
        } else {
          path.setAttribute("fill", "none");
        }
        
        // Set opacity
        if (this.opacity < 1) {
          path.setAttribute("opacity", this.opacity.toString());
        }
        
        buffer = [];
        let pt = getMousePosition(e);
        
        // Validate coordinates before using them
        if (pt.x === undefined || pt.y === undefined || isNaN(pt.x) || isNaN(pt.y)) {
          console.error('Invalid mouse position:', pt, 'rect:', rect);
          // Don't create the path if coordinates are invalid
          if (path && path.parentNode) {
            path.parentNode.removeChild(path);
          }
          path = null;
          return;
        }
        
        // console.log(e)
        appendToBuffer(pt);


        firstpoint = { x: (pt.x), y: (pt.y) };

        switch (shapedraw) {
          case 'circle':
            strPath = 'M ' + rect.top + ' ' + rect.left +
              'm -' + 0 + ', 0' +
              'a' + 0 + ',' + 0 + ' 0 1,0' + 0 * 2 + ',0' +
              'a' + 0 + ',' + 0 + ' 0 1,0 -' + 0 * 2 + ',0'
            break;
          case 'rectangle':
            strPath = 'M ' + pt.x + ' ' + pt.y + ' H ' + pt.x + ' V ' + pt.y + ' H ' + pt.x + ' Z';
            break;
          case 'line':
            // Start line at click point
            strPath = 'M ' + pt.x + ' ' + pt.y + ' L ' + pt.x + ' ' + pt.y;
            break;
          case 'star':
            // Initial star path (will be updated on mouse move)
            strPath = this.generateStarPath(pt.x, pt.y, 0, 0, 5);
            break;
          case 'polygon':
            // Initial polygon path (will be updated on mouse move)
            strPath = this.generatePolygonPath(pt.x, pt.y, 0, 6);
            break;
          default:
            strPath = "M" + pt.x + " " + pt.y;
        }

        //strPath = "M" + pt.x + " " + pt.y;
        path.setAttribute("d", strPath);
        svgElement.appendChild(path);
      });

      this.mousemove = svgElement.addEventListener("mousemove", (e) => {
        if (path) {
          switch (shapedraw) {
            case 'circle':
              updateSvgPathCircle(e);
              break;
            case 'rectangle':
              updateSvgPathRect(e);
              break;
            case 'line':
              updateSvgPathLine(e);
              break;
            case 'star':
              updateSvgPathStar(e);
              break;
            case 'polygon':
              updateSvgPathPolygon(e);
              break;
            default:
              appendToBuffer(getMousePosition(e));
              updateSvgPath();
          }
        }
      });

      this.mouseup = svgElement.addEventListener("mouseup", () => {
        this.saveHistory();
        if (path) {
          path = null;
        }
        if (firstpoint) {
          firstpoint = null;
        }
      });

      // add scroll event to track update rect for new scroll location
      const containerNormal = document.getElementById('containernormal');
      if (containerNormal) {
        containerNormal.addEventListener("scroll", (e) => {
          console.log('scroll');
          rect = svgElement.getBoundingClientRect();
        });
      }

      let getMousePosition = function (e: MouseEvent) {
        // Update rect in case element has moved/scrolled
        if (svgElement) {
          rect = svgElement.getBoundingClientRect();
        }
        
        const x = e.pageX - rect.left;
        const y = e.pageY - rect.top;
        
        return {
          x: x,
          y: y
        }
      };

      let appendToBuffer = (pt: { x: number; y: number; }) => {
        buffer.push(pt);
        while (buffer.length > bufferSize) {
          buffer.shift();
        }
      };

      let updateSvgPathCircle = (e: MouseEvent) => {
        let pl = svgElement.getElementsByTagName('path').length;
        let ptl = getMousePosition(e);
        // Calculate radius based on distance from first point to current mouse position
        const dx = ptl.x - firstpoint!.x;
        const dy = ptl.y - firstpoint!.y;
        const radiusX = Math.abs(dx);
        const radiusY = Math.abs(dy);
        
        // Create ellipse path using arc commands
        strPath = 'M ' + firstpoint!.x + ' ' + firstpoint!.y +
          ' m ' + (-radiusX) + ', 0' +
          ' a ' + radiusX + ',' + radiusY + ' 0 1,0 ' + (radiusX * 2) + ',0' +
          ' a ' + radiusX + ',' + radiusY + ' 0 1,0 ' + (radiusX * -2) + ',0';
        path!.setAttribute("d", strPath);
        const newid = 'wb' + pl + 1
        path!.setAttribute("id", newid);
      }

      let updateSvgPathLine = (e: MouseEvent) => {
        let pl = svgElement.getElementsByTagName('path').length;
        let ptl = getMousePosition(e);
        // Simple straight line from first point to current mouse position
        strPath = 'M ' + firstpoint!.x + ' ' + firstpoint!.y + ' L ' + ptl.x + ' ' + ptl.y;
        path!.setAttribute("d", strPath);
        const newid = 'wb' + pl + 1
        path!.setAttribute("id", newid);
      }

      let updateSvgPathRect = (e: MouseEvent) => {
        let pl = svgElement.getElementsByTagName('path').length;
        let ptl = getMousePosition(e);
        strPath = 'M ' + firstpoint!.x + ' ' + firstpoint!.y + ' H ' + ptl.x + ' V ' + ptl.y + ' H ' + firstpoint!.x + ' Z';
        path!.setAttribute("d", strPath);
        const newid = 'wb' + pl + 1
        path!.setAttribute("id", newid);
      }

      let updateSvgPathStar = (e: MouseEvent) => {
        let pl = svgElement.getElementsByTagName('path').length;
        let ptl = getMousePosition(e);
        // Calculate radius based on distance from first point
        const dx = ptl.x - firstpoint!.x;
        const dy = ptl.y - firstpoint!.y;
        const outerRadius = Math.sqrt(dx * dx + dy * dy);
        const innerRadius = outerRadius * 0.4; // Inner points at 40% of outer radius
        
        strPath = this.generateStarPath(firstpoint!.x, firstpoint!.y, outerRadius, innerRadius, 5);
        path!.setAttribute("d", strPath);
        const newid = 'wb' + pl + 1
        path!.setAttribute("id", newid);
      }

      let updateSvgPathPolygon = (e: MouseEvent) => {
        let pl = svgElement.getElementsByTagName('path').length;
        let ptl = getMousePosition(e);
        // Calculate radius based on distance from first point
        const dx = ptl.x - firstpoint!.x;
        const dy = ptl.y - firstpoint!.y;
        const radius = Math.sqrt(dx * dx + dy * dy);
        
        strPath = this.generatePolygonPath(firstpoint!.x, firstpoint!.y, radius, 6);
        path!.setAttribute("d", strPath);
        const newid = 'wb' + pl + 1
        path!.setAttribute("id", newid);
      }

      // Calculate the average point, starting at offset in the buffer
      let getAveragePoint = (offset: number) => {
        let len = buffer.length;
        if (len % 2 === 1 || len >= bufferSize) {
          let totalX = 0;
          let totalY = 0;
          let pt, i;
          let count = 0;
          for (i = offset; i < len; i++) {
            count++;
            pt = buffer[i];
            totalX += pt.x;
            totalY += pt.y;
          }
          return {
            x: totalX / count,
            y: totalY / count
          }
        }
        return null;
      };

      let updateSvgPath = () => {
        let pt = getAveragePoint(0);
        let pl = svgElement.getElementsByTagName('path').length;

        if (pt) {
          // Get the smoothed part of the path that will not change
          strPath += " L" + pt.x + " " + pt.y;

          // Get the last part of the path (close to the current mouse position)
          // This part will change if the mouse moves again
          let tmpPath = "";
          for (let offset = 2; offset < buffer.length; offset += 2) {
            pt = getAveragePoint(offset);
            tmpPath += " L" + pt!.x + " " + pt!.y;
          }

          // Set the complete current path coordinates
          path!.setAttribute("d", strPath + tmpPath);
          const newid = 'wb' + pl + 1
          path!.setAttribute("id", newid);
        }
      };
    }, 300) // mininmum needed for dom to process

  }

  mergePath() {
    // let newd = d + ' ' + d
  }

  substractPath() {

  }




}
